import React, { useContext, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Observer } from "mobx-react-lite";
import ProductionDashboardStore from "./stores/productiondashboardstore";
import { createContext } from "react";
import { toJS } from "mobx";
import { Skeleton } from "antd";
import $ from "jquery";
const _ = require("underscore");
const ProductionDashboardStoreCtx = createContext(ProductionDashboardStore);

const toFiniteNumber = (value) => {
  const number = Number(toJS(value));
  return Number.isFinite(number) ? number : 0;
};

const sumValues = (values) =>
  _.reduce(
    values,
    function (memo, num) {
      return memo + toFiniteNumber(num);
    },
    0
  );

const formatBopd = (value) => Number(toFiniteNumber(value).toFixed(2)).toLocaleString() + "bopd";

export const DonutChart = ({
  showLabel,
  showLegend,
  oilcol,
  gascol,
  nglcol,
  boecol,
}) => {
  const productionDashboardStore = useContext(ProductionDashboardStoreCtx);

  const drillupTitle = () =>
    "Total BOE<br/><span style='color:red'>" +
    formatBopd(
      sumValues(
        [...productionDashboardStore.productions.values()].map((x) => x[boecol])
      )
    );

  const drilldownTitle = (seriesOptions) => {
    return (
      `<span style='color: #FFCC2A'>Total ${seriesOptions.name} BOE</span><br/><span style='color:white'>` +
      formatBopd(sumValues(seriesOptions.data.map((x) => x[1])))
    );
  };
  // Positioning the title

  useEffect(() => {
    async function getData() {
      await productionDashboardStore.getDashboardData();
    }
    getData();
  }, []);

  return (
    <Observer>
      {() =>
        productionDashboardStore.isLoading ? (
          <>
            <div style={{ padding: "15px" }}>
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </div>
          </>
        ) : (
          <HighchartsReact
            highcharts={Highcharts}
            options={{
              chart: {
                renderTo: "container",
                type: "pie",
                events: {
                  drilldown: function (e) {
                    var chart = this;

                    chart.setTitle({
                      text: drilldownTitle(e.seriesOptions),
                    });
                  },
                  drillup: function (e) {
                    var chart = this;

                    chart.setTitle({ text: drillupTitle() });
                  },
                },
              },
              colors: [
                "#3E4095",
                "#DE2836",
                "#FECB2B",
                "#80699B",
                "#3D96AE",
                "#DB843D",
                "#92A8CD",
                "#A47D7C",
                "#B5CA92",
              ],
              credits: {
                enabled: true,
                text: "source: SPARS",
                href: "mailto:projects@cybersprintitsolutions.com",
              },

              title: {
                text: drillupTitle(),
                align: "center",
                verticalAlign: "middle",
                style: {
                  fontWeight: "bold",
                  fontSize: "14px",
                },
                y: -20, // Positioning the title
              },
              events: {
                load: function (event) {
                  var total = 0; // get total of data
                  for (
                    var i = 0, len = this.series[0].yData.length;
                    i < len;
                    i++
                  ) {
                    total += this.series[0].this.y[i];
                  }
                  this.renderer
                    .text("Total: " + total, this.plotLeft, this.plotTop - 20)
                    .attr({ zIndex: 5 })
                    .add();
                },
              },
              tooltip: {
                formatter: function () {
                  return (
                    "<b>" +
                    this.point.name +
                    "</b>:<br/>" +
                    Math.round(this.y).toLocaleString() +
                    "bopd" +
                    "</b>:<br/>" +
                    Number(this.percentage).toFixed(2) +
                    "%"
                  );
                },
              },
              legend: {
                enabled: showLegend,
                floating: false,
                borderWidth: 0,
                align: "center",
                layout: "horizontal",
                verticalAlign: "bottom",
                labelFormatter: function () {
                  return (
                    '<span style="font-family:Verdana, Geneva, sans-serif; font-weight: normal; font-size:10px">' +
                    this.name +
                    " </span>"
                  );
                },
              },
              yAxis: {
                title: {
                  text: "",
                },
              },
              plotOptions: {
                pie: {
                  shadow: false,
                },
              },
              series: [
                {
                  name: "Total Boe",
                  data: [...productionDashboardStore.productions.values()].map(
                    (x) => {
                      return {
                        name: toJS(x.asset),
                        y: toFiniteNumber(x[boecol]),
                        drilldown: toJS(x.asset),
                      };
                    }
                  ),

                  size: "100%",
                  innerSize: "65%",
                  showInLegend: showLegend,
                  dataLabels: {
                    enabled: showLabel,
                    formatter: function () {
                      if (showLegend) {
                        return (
                          '<span style="font-family:Verdana, Geneva, sans-serif; font-weight: normal; font-size:10px">' +
                          Math.round(this.point.y).toLocaleString() +
                          ": <br/>" +
                          Number(this.percentage).toFixed(2) +
                          "%" +
                          " </span>"
                        );
                      } else {
                        return (
                          '<span style="font-family:Verdana, Geneva, sans-serif; font-weight: normal; font-size:10px">' +
                          this.key +
                          ": <br/>" +
                          Math.round(this.point.y).toLocaleString() +
                          ": <br/>" +
                          Number(this.percentage).toFixed(2) +
                          "%" +
                          " </span>"
                        );
                      }
                    },
                  },
                },
              ],
              drilldown: {
                series: [...productionDashboardStore.productions.values()].map(
                  (x, idx) => {
                    return {
                      name: toJS(x.asset),
                      id: toJS(x.asset),
                      data: [
                        ["Oil", toFiniteNumber(x[oilcol])],
                        ["Gas", toFiniteNumber(x[gascol])],
                        ["Ngl", toFiniteNumber(x[nglcol])],
                      ],
                    };
                  }
                ),
              },

              function(chart) {
                // on complete
                var textX = chart.plotLeft + chart.plotWidth * 0.5;
                var textY = chart.plotTop + chart.plotHeight * 0.5;

                var span =
                  '<span id="pieChartInfoText" style="position:absolute; text-align:center;">';
                span += '<span style="font-size: 32px">Upper</span><br>';
                span += '<span style="font-size: 16px">Lower</span>';
                span += "</span>";

                $("#addText").append(span);
                span = $("#pieChartInfoText");
                span.css("left", textX + span.width() * -0.5);
                span.css("top", textY + span.height() * -0.5);
              },
            }}
          />
        )
      }
    </Observer>
  );
};

